import { B2Tabs } from "@hdb/biome-2";
import { createRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import userDummyPic from "../../../src/assets/images/user-dummy-pic.png";
import ContentHeader from "../../shared/content-header/content-header.component";
import FormBuilderComponent, {
  FormConfig,
} from "../../shared/form-builder/form-builder.component";
import {
  getUserById,
  getUserMfaInfo,
  getuserbyemail
} from "../../store/slices/user.slice";

const ProfilePageComponent = () => {
  const dispatch = useDispatch();
  const formRef = createRef();
  // const isUserLoggedIn = isLoggedIn();

  const [initialValues, setInitialValues] = useState<any>({
    email: "",
    role: "",
    // secretCode: "",
  });

  const [userInfo, setUserInfo] = useState({} as any);
  /*   const [isMfaEnabled, setIsMfaEnabled] = useState(false);
    const [isDmsMfaEnabled, setIsDmsMfaEnabled] = useState(false); */

  /*   const base64String = useSelector((state: any) => {
      return state.otp.base64String;
    }); */

  /*   const mfaInfo = useSelector((state: any) => {
      return state.user.mfaInfo;
    }); */

  const userDetails = useSelector((state: any) => {
    return state.user.userDetails;
  });

  const userbyEmail = useSelector((state: any) => {
    return state.user.userbyEmail;
  });

  const validationSchema = yup.object().shape({
    email: yup.string().required("User Id is required"),
    role: yup.string().required("Role is required"),
    // secretCode: yup
    //   .string()
    //   .required("secretCode is required")
    //   .max(8, "Secret Code must be at most 8 characters"),
  });

  /*   const generateQrCode = () => {
      dispatch(getMfaOtp());
    };
  
    const updateUserMfaInfo = () => {
      dispatch(
        updateMfaInfo({
          email: userInfo.email.toLowerCase(),
          isMfaEnabled: isMfaEnabled,
          isDMSMfaEnabled: isDmsMfaEnabled,
        })
      ).then((res: any) => {
        dispatch(getUserMfaInfo());
      });
    }; */

  useEffect(() => {
    // const user = getUserInfo();
    dispatch(getuserbyemail());
  }, []);

  useEffect(() => {
    if (!userbyEmail?.id) return;
    dispatch(getUserById({ id: userbyEmail.id }));
  }, [userbyEmail]);

  useEffect(() => {
    if (
      !userDetails?.email &&
      !userDetails?.roleName
      // && !userDetails?.secretCode
    )
      return;
    setUserInfo(userDetails);

    setInitialValues({
      email: userDetails.profileName,
      role: userDetails?.roleName,
      // secretCode: userDetails?.secretCode,
    });

    dispatch(getUserMfaInfo());
  }, [userDetails]);

  /*   useEffect(() => {
      if (Object.keys(mfaInfo).length) {
        setIsMfaEnabled(mfaInfo?.isMfaEnabled);
        setIsDmsMfaEnabled(mfaInfo?.isDMSMfaEnabled);
      }
    }, [mfaInfo]); */

  const formConfig: FormConfig = {
    controls: [
      {
        name: "email",
        label: "Profile Name",
        placeholder: "user@sj.com",
        type: "text",
        required: true,
        readOnly: true,
        disabled: true,
      },

      {
        name: "role",
        label: "Role",
        placeholder: "HDB Admin",
        type: "text",
        required: true,
        readOnly: true,
        disabled: true,
      },
      // {
      //   name: "secretCode",
      //   label: "Secret Code",
      //   placeholder: "******",
      //   type: "password",
      //   required: true,
      // },
    ],
  };

  /*   const handleMfaChange = (e: any) => {
      setIsMfaEnabled(e.target.checked);
    };
  
    const handleDmsMfaChange = (e: any) => {
      setIsDmsMfaEnabled(e.target.checked);
    }; */

  // const handleSubmit = () => {
  //   const form: any = formRef.current;
  //   if (form) {
  //     const email = form.values?.email;
  //     const secretCode = form.values?.secretCode;

  //     if (!secretCode || secretCode?.length > 8) {
  //       return;
  //     }
  //     dispatch(updateSecretCode({ email: email, secretCode: secretCode }));
  //   }
  // };

  return (
    <>
      <Helmet>
        <title>Profile | SLP</title>
      </Helmet>
      <div>
        <div className="header-container">
          <div className="title-container">
            <ContentHeader pageTitle="Profile"></ContentHeader>
          </div>
        </div>

        <div className="page">
          <div className="page-container mt-3">
            <div
              className="bg-card shadow-sm flex flex-col justify-content-center"
              style={{ gap: "2rem" }}
            >
              <div
                style={{
                  display: "flex",
                  borderBottom: "1px dashed 1976D2",
                  padding: "2rem",
                }}
                className="flex-sm-row flex-column align-items-center"
              >
                <img
                  style={{ width: "160px" }}
                  src={userDummyPic}
                  alt="Profile Avatar"
                />
                <div
                  className="mt-2"
                  style={{
                    marginLeft: "1rem",
                    fontSize: "18px",
                    fontWeight: 700,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div>{userInfo.email}</div>
                  <div
                    style={{
                      color: "1976D2",
                      marginTop: "0.5rem",
                    }}
                  >
                    {userInfo.roleName}
                  </div>
                </div>
              </div>

              <div
                style={{
                  padding: "0 2rem",
                }}
              >
                <div className="custom_tab_start">
                  <B2Tabs
                    activeKey="UserInfo"
                    pills
                    tabClassName={""}
                    onSelect={(selectedId: any) => {}}
                    tab={[
                      {
                        content: (
                          <div
                            className="profile-tab-content"
                            style={{
                              padding: "2rem",
                            }}
                          >
                            <div style={{}}>
                              <FormBuilderComponent
                                formRef={formRef}
                                initialValues={initialValues}
                                validation={validationSchema}
                                formConfig={formConfig}
                              />

                              {/* <div className="flex">
                                {isUserLoggedIn && (
                                  <B2Button
                                    variant="primary"
                                    onClick={() => handleSubmit()}
                                  >
                                    Save
                                  </B2Button>
                                )}
                              </div> */}
                            </div>
                          </div>
                        ),
                        id: "UserInfo",
                        title: "User Information",
                      },
                      // {
                      //   content: (
                      //     <div
                      //       style={{
                      //         width: "70%",
                      //         padding: "2rem",
                      //       }}
                      //     >
                      //       <div
                      //         className="flex"
                      //         style={{
                      //           justifyContent: "space-between",
                      //           alignItems: "center",
                      //         }}
                      //       >
                      //         <div className="w-lg-30">
                      //           Enable MFA For Login
                      //         </div>
                      //         <div className=" w-lg-70">
                      //           <Form.Group controlId="validationFormik01">
                      //             <Form.Check
                      //               type="switch"
                      //               name="mfaEnabled"
                      //               onChange={handleMfaChange}
                      //               checked={isMfaEnabled}
                      //             />
                      //           </Form.Group>
                      //         </div>
                      //       </div>

                      //       <div
                      //         className="flex mt-3"
                      //         style={{
                      //           justifyContent: "space-between",
                      //           alignItems: "center",
                      //         }}
                      //       >
                      //         <div className="w-lg-30">Enable DMS MFA</div>
                      //         <div className="w-lg-70">
                      //           <Form.Group controlId="validationFormik01">
                      //             <Form.Check
                      //               type="switch"
                      //               name="mfaEnabled"
                      //               onChange={handleDmsMfaChange}
                      //               checked={isDmsMfaEnabled}
                      //             />
                      //           </Form.Group>
                      //         </div>
                      //       </div>

                      //       <div className="flex mt-3">
                      //         {isUserLoggedIn && (
                      //           <div>
                      //             <B2Button
                      //               variant="primary"
                      //               onClick={() => updateUserMfaInfo()}
                      //             >
                      //               Save
                      //             </B2Button>
                      //           </div>
                      //         )}
                      //       </div>
                      //     </div>
                      //   ),
                      //   id: "Settings", // settings
                      //   title: "Settings",
                      // },
                      // {
                      //   content: (
                      //     <div
                      //       style={{
                      //         width: "30%",
                      //         padding: "2rem",
                      //       }}
                      //     >
                      //       <div className="">
                      //         <div
                      //           style={{
                      //             fontSize: "18px",
                      //             fontWeight: "700",
                      //           }}
                      //         >
                      //           Authenticator App Setting
                      //         </div>

                      //         {base64String ? (
                      //           <div>
                      //             <B2Button
                      //               className="mt-3"
                      //               onClick={() => generateQrCode()}
                      //               variant="primary"
                      //             >
                      //               Regenerate QR Code
                      //               <FontAwesomeIcon
                      //                 icon={faQrcode}
                      //                 className="fs-7 ms-2"
                      //               />
                      //             </B2Button>
                      //             <div
                      //               className="mt-3"
                      //               style={{
                      //                 marginLeft: "-10px",
                      //               }}
                      //             >
                      //               <img src={base64String} alt="" />
                      //             </div>
                      //           </div>
                      //         ) : (
                      //           <B2Button
                      //             className="mt-3"
                      //             variant="primary"
                      //             onClick={() => generateQrCode()}
                      //           >
                      //             Generate QR Code
                      //             <FontAwesomeIcon
                      //               icon={faQrcode}
                      //               className="fs-7 ms-2"
                      //             />
                      //           </B2Button>
                      //         )}
                      //       </div>
                      //     </div>
                      //   ),
                      //   id: "Qr", // qr
                      //   title: "QR Code",
                      // },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfilePageComponent;
